import React, { useEffect, useState } from 'react';
import { Env } from '../../../Helpers/Env';
import { Icon } from 'antd';
import moment from 'moment/moment';

const BannerEvent = (props) => {
   const [showBanner, setShowBanner] = useState(false);
   const [eventsInfo, setEventsInfo] = useState();

   const [redirectTo, setRedirectTo] = useState('#');
   const [redirectPathname, setRedirectPathname] = useState(null);

   const onBannerClick = () => {
      Env.event = true;
      setShowBanner(false);
      window.location.href = redirectTo;
   };

   const eventVisible = (date) => {
      return moment().diff(moment(date), 'days') <= 0;
   };

   useEffect(() => {
      const config = Env?.configs?.event;
      if (config) {
         Env.event_start_date = config.start_date;
         Env.event_limit_date = config.end_date;

         setEventsInfo(config);
         const redirectUrl = config?.redirect_to || '#';
         setRedirectTo(redirectUrl);

         let redirectPath = null;
         try {
            if (redirectUrl && redirectUrl.includes('://')) {
               redirectPath = new URL(redirectUrl).pathname;
            }
         } catch (e) {
            // Se der erro ao parsear a URL, não oculta o banner
         }

         const currentPath = window.location.pathname;
         setRedirectPathname(currentPath);
         const shouldHideBanner = redirectPath && currentPath === redirectPath;
         const isVisible = eventVisible(config.end_date) && !shouldHideBanner;
         setShowBanner(isVisible);
      }
   }, []);

   if (showBanner) {
      return props.isModal ?
            <>
               {showBanner && (
                  <div className={'modal-event'}>
                     <div className={'bannerMain pulse-pink'}>
                        <div
                           className={'icon'}
                           onClick={() => {
                              setShowBanner(false);
                           }}
                        >
                           <Icon style={{ zIndex: 99999 }} type={'close'} />
                        </div>
                        <img
                           alt={'banner'}
                           onClick={onBannerClick}
                           style={{ maxHeight: window.innerHeight - 100, maxWidth: '100%' }}
                           src={eventsInfo?.image}
                        />
                     </div>
                  </div>
               )}
            </>
         :  <div style={{ padding: '0 10px' }}>
               <img
                  alt={'banner'}
                  onClick={
                     props.onClick ?
                        props.onClick
                     :  window.location.pathname !== redirectPathname && onBannerClick
                  }
                  style={{
                     width: '100%',
                     objectFit: 'cover',
                     borderRadius: 10,
                     minHeight: 150,
                     cursor: `${window.location.pathname !== '/vagas-do-evento' ? 'pointer' : 'default'}`,
                     ...props.style,
                  }}
                  src={eventsInfo?.image}
                  className={`cursor-pointer ${props.pulseNone ? '' : 'pulse'}`}
               />
            </div>;
   } else return <></>;
};

export default BannerEvent;
